module.exports = __webpack_public_path__ + "static/media/ss-logo.af84071f.svg";